import { useEffect, useRef } from 'react';

type UseBarcodeScannerProps = {
  onScan: (barcode: string) => void;
  isActive?: boolean;
};

export const useBarcodeScanner = ({ onScan, isActive = true }: UseBarcodeScannerProps) => {
  const scannedString = useRef<string>('');
  const lastKeyTime = useRef<number>(0);

  useEffect(() => {
    if (!isActive) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      const currentTime = Date.now();
      const timeDiff = currentTime - lastKeyTime.current;
      
      if (timeDiff > 50) {
        scannedString.current = '';
      }

      if (!e.key) return;

      if (e.key === 'Enter') {
        if (scannedString.current.length > 3) {
          onScan(scannedString.current);
          scannedString.current = '';
          e.preventDefault(); 
        }
      } else if (e.key.length === 1) {
        scannedString.current += e.key;
      }

      lastKeyTime.current = currentTime;
    };

    globalThis.addEventListener('keydown', handleKeyDown);

    return () => {
      globalThis.removeEventListener('keydown', handleKeyDown);
    };
  }, [onScan, isActive]);

  return null;
};
